import React from 'react'
import classNames from 'classnames'
import styles from './Label.module.css'
import { default as generalStyle } from '../Theme/GeneralTheme.module.css'

function Label({ ...props }) {

  const { className, ...rest } = props;
  const childrenClassNames = classNames([generalStyle.general_style, styles.label], className)

  return (
    <label className={childrenClassNames} {...rest}>
      {props.children}
    </label>
  )
}

export { Label }
